import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderComponent, withHandlers, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { adminActions } from '../../../../state/modules/admin';
import { InputFormField, ServerError } from '../../../components';
import Loading from '../../loading';

const validate = ({ name }) => ({
  name: (name && name.length > 0) ? null : 'Name is required.'
})

const isValid = ({ name, isUnique }) => !name && !isUnique

const AdminQualificationTypeEdit = ({
  qualificationType,
  error,
  updateName,
  updateQualificationType,
  deleteQualificationType,
  validation
}) => (
    <div id='section--admin-qualification-type-edit'>
      <h1 className='text-center'>
        {
          qualificationType.id ? 'Edit Qualification Type' : 'Add Qualification Type'
        }
      </h1>
      <Grid>
        <Row className='md-gutter'>
          <Col xs={12} md={8} mdOffset={2} className='boxed text-left'>
            <form onSubmit={updateQualificationType}>
              <Row>
                <Col xs={12}>
                  <ServerError error={error} hideSupport />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <InputFormField {...{
                    id: 'name',
                    onChange: (e) => updateName(e.target.value),
                    validation: validation.name,
                    value: qualificationType.name
                  }} />
                </Col>
              </Row>
              <Row className='top-gap'>
                <Col xs={12}>
                  <Button
                    className='flex-center'
                    type='submit'>
                    {
                      qualificationType.id ? 'Update' : 'Create'
                    }
                  </Button>
                </Col>
              </Row>
              <Row className='top-gap'>
                {
                  qualificationType.id ? <Col xs={12}>
                    <Button
                      className='full btn-delete'
                      onClick={() => deleteQualificationType(qualificationType.id)}>
                      DELETE
                    </Button>
                  </Col> : null
                }
              </Row>
            </form>
          </Col>
        </Row>
      </Grid>
    </div>
  );

const mapStateToProps = (state) => ({
  qualificationTypes: fp.get('qualificationTypes')(state.user.profile),
  error: state.admin.error,
})
const mapDispatchToProps = (dispatch) => ({
  updateQualificationType: bindActionCreators(adminActions.admin.updateQualificationType, dispatch),
  addQualificationType: bindActionCreators(adminActions.admin.addQualificationType, dispatch),
  deleteQualificationType: bindActionCreators(adminActions.admin.deleteQualificationType, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ qualificationTypes }) => !qualificationTypes || qualificationTypes.length === 0,
    renderComponent(Loading)
  ),
  withStateHandlers(
    ({
      match: {
        params: { qualificationTypeId }
      },
      qualificationTypes
    }) => ({
      qualificationType: qualificationTypeId ?
        qualificationTypes.find(({ id }) => id === parseInt(qualificationTypeId, 10)) : {
          name: undefined,
        },
      validation: {}
    }),
    {
      updateName: ({ qualificationType }) => (name) => ({
        qualificationType: {
          ...qualificationType,
          name
        }
      }),
      setValidation: () => (validation) => ({ validation })
    }
  ),
  withHandlers({
    updateQualificationType: ({ updateQualificationType, addQualificationType, qualificationType, setValidation }) => (e) => {
      e.preventDefault();
      e.stopPropagation();

      const validation = validate(qualificationType)
      if (isValid(validation)) {
        if (qualificationType.id) {
          updateQualificationType(
            qualificationType.id,
            qualificationType
          );
        } else {
          addQualificationType(qualificationType);
        }
      } else {
        setValidation(validation)
      }
    }
  }),
  lifecycle({
    componentDidUpdate() {
      const validation = this.props.validation;
      if (!isValid(validation)) {
        const nextValidation = validate(this.props.qualificationType);
        if (JSON.stringify(nextValidation) !== JSON.stringify(validation)) {
          this.props.setValidation(nextValidation);
        }
      }
    }
  })
)(AdminQualificationTypeEdit);


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/qualification-type-portal/qualification-type-edit.js